(() => {
  if (window.MCArticleLayout) return

  const hasImage = (element) => {
    return element.matches('img') || Boolean(element.querySelector('img'))
  }

  const hasVisibleContent = (element) => {
    return Boolean(element.textContent.trim() || element.querySelector('br, hr'))
  }

  const removeEmptyElements = (element) => {
    Array.from(element.children).forEach(removeEmptyElements)

    if (!element.textContent.trim() && !element.querySelector('br, hr, img')) {
      element.remove()
    }
  }

  const normalizeImageBlocks = (body) => {
    const children = Array.from(body.children)

    children.forEach((element) => {
      const images = element.matches('img') ? [element] : Array.from(element.querySelectorAll('img'))
      const image = images[0]

      if (!image || images.length !== 1 || !element.matches('p')) return

      const contentWithoutImage = element.cloneNode(true)
      contentWithoutImage.querySelectorAll('img').forEach((node) => node.remove())
      removeEmptyElements(contentWithoutImage)

      if (!hasVisibleContent(contentWithoutImage)) return

      const mediaBlock = element.cloneNode(false)
      mediaBlock.appendChild(image)

      if (hasVisibleContent(contentWithoutImage)) {
        element.replaceWith(mediaBlock, contentWithoutImage)
      } else {
        element.replaceWith(mediaBlock)
      }
    })
  }

  const markMediaBlocks = (column) => {
    Array.from(column.children).forEach((element) => {
      if (hasImage(element)) element.classList.add('mc-article__media-block')
    })
  }

  const splitArticleBody = (body) => {
    if (body.dataset.mcArticleLayoutReady === 'true') return

    normalizeImageBlocks(body)

    const children = Array.from(body.children)
    const firstImageIndex = children.findIndex(hasImage)

    if (firstImageIndex === -1) return

    const secondImageIndex = children.findIndex((element, index) => {
      return index > firstImageIndex && hasImage(element)
    })

    if (secondImageIndex === -1) return

    const leadContent = children.slice(0, firstImageIndex)
    const firstColumnContent = children.slice(firstImageIndex, secondImageIndex)
    const secondColumnContent = children.slice(secondImageIndex)
    const columns = document.createElement('div')
    const firstColumn = document.createElement('div')
    const secondColumn = document.createElement('div')

    columns.className = 'mc-article__content-columns'
    firstColumn.className = 'mc-article__content-column'
    secondColumn.className = 'mc-article__content-column'

    leadContent.forEach((element) => body.appendChild(element))
    body.appendChild(columns)
    firstColumnContent.forEach((element) => firstColumn.appendChild(element))
    secondColumnContent.forEach((element) => secondColumn.appendChild(element))
    columns.append(firstColumn, secondColumn)
    markMediaBlocks(firstColumn)
    markMediaBlocks(secondColumn)
    body.classList.add('mc-article__body--split')
    body.dataset.mcArticleLayoutReady = 'true'
  }

  const init = (container = document) => {
    container.querySelectorAll('.mc-article__body').forEach(splitArticleBody)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true })
  } else {
    init()
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target))
  window.MCArticleLayout = { init }
})()
